import { RouteRecordRaw } from "vue-router"
import AppLayout from "@/components/AppLayout/AppLayout.vue";
import path from "path";
import { Components } from "ant-design-vue/es/date-picker/generatePicker";
/**
 * @param hidden true隐藏路由 false不隐藏路由,
 * @param title 菜单标题必填
 * @param breadcrumb 面包屑,
 * @param alwaysShow 一直显示,
 * @param displayRoute 是否在左侧菜单中隐藏，默认为false,
 */
const routers: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: AppLayout,
    redirect: '/MemberCenterList',
    children: [
      {
        path: '/',
        name: 'MemberCenterList',
        component: () => import('@/views/MemberCenter/List.vue'),
        meta: {
          title: '会员中心',
          icon: require('@/assets/images/member.png'),
          breadcrumb: [
            {
              name: '会员中心',
            }
          ],

        }
      },
    ]
  },
  {
    path: '/PointsManagement',
    component: AppLayout,
    redirect: '/PointsManagement/PointsDetails',
    meta: {
      title: '积分管理',
      icon: require('@/assets/images/points.png'),
      alwaysShow: false,
      // displayRoute: true,
    },
    children: [
      {
        path: 'pointsDetails',
        name: 'pointsDetails',
        component: () => import('@/views/PointsManagement/PointsDetails.vue'),
        meta: {
          title: '积分明细',
          // hidden: true,
          // alwaysShow:false,
          breadcrumb: [
            {
              name: '积分明细',
            }
          ]
        }
      },
      {
        path: 'redeem',
        name: 'redeem',
        component: () => import('@/views/PointsManagement/Redeem.vue'),
        meta: {
          title: '积分兑换',
          // hidden: true,
          // alwaysShow:false,
          breadcrumb: [
            {
              name: '积分兑换',
            }
          ]
        }
      },
      {
        path: 'exchangeRecords',
        name: 'exchangeRecords',
        component: () => import('@/views/PointsManagement/ExchangeRecords.vue'),
        meta: {
          title: '兑换记录',
          // hidden: true,
          // alwaysShow:false,
          breadcrumb: [
            {
              name: '兑换记录',
            }
          ]
        }
      },
    ]
  },

  {
    path: '/AnalysisTools',
    component: AppLayout,
    meta: {
      title: '通用云平台',
      icon: require('@/assets/images/cloud.png'),
    },
    children: [
      {
        path: 'Analysis',
        name: 'Analysis',
        component: () => import('@/views/AnalysisTools/tools/index.vue'),
        meta: {
          title: '云工具',
          breadcrumb: [
            {
              name: '云工具',
            }
          ]
        },
      },
       {
        path: 'Process',
        name: 'Process',
        component: () => import('@/views/AnalysisTools/process/index.vue'),
        meta: {
          title: '云流程',
          breadcrumb: [
            {
              name: '云流程',
            }
          ]
        },
      },
      {
        path: 'Operation',
        name: 'Operation',
        component: () => import('@/views/AnalysisTools/operation.vue'),
        meta: {
          title: '云工具运行界面',
          breadcrumb: [
            {
              name: '云工具运行界面',
              path: '/AnalysisTools/Operation'
            }
          ]
        }
      },
      {
        path: 'OperationProcess',
        name: 'OperationProcess',
        component: () => import('@/views/AnalysisTools/operationProcess.vue'),
        meta: {
          title: '云流程运行界面',
          breadcrumb: [
            {
              name: '云流程运行界面',
              path: '/AnalysisTools/OperationProcess'
            }
          ]
        }
      },
       {
        path: 'CloudVisualization',
        name: 'CloudVisualization',
        component: () => import('@/views/AnalysisTools/visualization/index.vue'),
        meta: {
          title: '云可视化',
          breadcrumb: [
            {
              name: '云可视化',
            }
          ]
        },
      },
      //工具1
      {
        path: 'KEGG',
        name: 'KEGG',
        component: () => import('@/views/AnalysisTools/tools/kegg.vue'),
        meta: {
          title: 'KEGG富集分析',
          hidden: true,
          breadcrumb: [
            {
              name: '云工具',
              path: '/AnalysisTools/Analysis'
            },
            {
              name: 'KEGG富集分析',
            }
          ]
        }
      },
      //工具2
      {
        path: 'GO',
        name: 'GO',
        component: () => import('@/views/AnalysisTools/tools/go.vue'),
        meta: {
          title: 'GO富集分析',
          hidden: true,
          breadcrumb: [
            {
              name: '云工具',
              path: '/AnalysisTools/Analysis'
            },
            {
              name: 'GO富集分析',
              path: '/AnalysisTools/GO'
            }
          ]
        }
      },
      //工具3
      {
        path: 'Bubble',
        name: 'Bubble',
        component: () => import('@/views/AnalysisTools/tools/bubble.vue'),
        meta: {
          title: '富集气泡图',
          hidden: true,
          breadcrumb: [
            {
              name: '云工具',
              path: '/AnalysisTools/Analysis'
            },
            {
              name: '富集气泡图',
              path: '/AnalysisTools/Bubble'
            }
          ]
        }
      },
      //工具4
      {
        path: 'Heat',
        name: 'Heat',
        component: () => import('@/views/AnalysisTools/tools/heat.vue'),
        meta: {
          title: '热图',
          hidden: true,
          breadcrumb: [
            {
              name: '云工具',
              path: '/AnalysisTools/Analysis'
            },
            {
              name: '热图',
              path: '/AnalysisTools/Heat'
            }
          ]
        }
      },
      //工具5
      {
        path: 'Volcano',
        name: 'Volcano',
        component: () => import('@/views/AnalysisTools/tools/volcano.vue'),
        meta: {
          title: '火山图',
          hidden: true,
          breadcrumb: [
            {
              name: '云工具',
              path: '/AnalysisTools/Analysis'
            },
            {
              name: '火山图',
              path: '/AnalysisTools/Volcano'
            }
          ]
        }
      },
      //工具6
      {
        path: 'Diffanalysis',
        name: 'Diffanalysis',
        component: () => import('@/views/AnalysisTools/tools/diffanalysis.vue'),
        meta: {
          title: '差异分析',
          hidden: true,
          breadcrumb: [
            {
              name: '云工具',
              path: '/AnalysisTools/Analysis'
            },
            {
              name: '火山图',
              path: '/AnalysisTools/Diffanalysis'
            }
          ]
        }
      },
      //工具7
      {
        path: 'PCA',
        name: 'PCA',
        component: () => import('@/views/AnalysisTools/tools/pca.vue'),
        meta: {
          title: 'PCA',
          hidden: true,
          breadcrumb: [
            {
              name: '云工具',
              path: '/AnalysisTools/Analysis'
            },
            {
              name: 'PCA',
              path: '/AnalysisTools/PCA'
            }
          ]
        }
      },//工具8
      {
        path: 'Correlation',
        name: 'Correlation',
        component: () => import('@/views/AnalysisTools/tools/correlation.vue'),
        meta: {
          title: '样品间相关性分析',
          hidden: true,
          breadcrumb: [
            {
              name: '云工具',
              path: '/AnalysisTools/Analysis'
            },
            {
              name: '样品间相关性分析',
              path: '/AnalysisTools/Correlation'
            }
          ]
        }
      },
      //工具9
      {
        path: 'Network',
        name: 'Network',
        component: () => import('@/views/AnalysisTools/tools/network.vue'),
        meta: {
          title: '相互作用网络图',
          hidden: true,
          breadcrumb: [
            {
              name: '云工具',
              path: '/AnalysisTools/Analysis'
            },
            {
              name: '相互作用网络图',
              path: '/AnalysisTools/Network'
            }
          ]
        }
      },
      //工具10
      {
        path: 'Blast',
        name: 'Blast',
        component: () => import('@/views/AnalysisTools/tools/blast.vue'),
        meta: {
          title: 'Blast序列局部比对',
          hidden: true,
          breadcrumb: [
            {
              name: '云工具',
              path: '/AnalysisTools/Analysis'
            },
            {
              name: 'Blast序列局部比对',
              path: '/AnalysisTools/Blast'
            }
          ]
        }
      },
      {
        path: 'Reportjxx',
        name: 'Reportjxx',
        component: () => import('@/views/AnalysisTools/tools/reportjxx.vue'),
        meta: {
          title: '九象限图',
          hidden: true,
          breadcrumb: [
            {
              name: '云工具',
              path: '/AnalysisTools/Analysis'
            },
            {
              name: '九象限图',
              path: '/AnalysisTools/Reportjxx'
            }
          ]
        }
      },
      {
        path: 'O2PLS',
        name: 'O2PLS',
        component: () => import('@/views/AnalysisTools/tools/o2pls.vue'),
        meta: {
          title: 'O2PLS分析',
          hidden: true,
          breadcrumb: [
            {
              name: '云工具',
              path: '/AnalysisTools/Analysis'
            },
            {
              name: 'O2PLS分析',
              path: '/AnalysisTools/O2PLS'
            }
          ]
        }
      },
      {
        path: 'ReportHeatnetwork',
        name: 'ReportHeatnetwork',
        component: () => import('@/views/AnalysisTools/tools/report_heatnetwork.vue'),
        meta: {
          title: '网络热图',
          hidden: true,
          breadcrumb: [
            {
              name: '云工具',
              path: '/AnalysisTools/Analysis'
            },
            {
              name: '网络热图',
              path: '/AnalysisTools/ReportHeatnetwork'
            }
          ]
        }
      },
      {
        path: 'Reporticawg',
        name: 'Reporticawg',
        component: () => import('@/views/AnalysisTools/tools/reporticawg.vue'),
        meta: {
          title: '相关性热图（组内）',
          hidden: true,
          breadcrumb: [
            {
              name: '云工具',
              path: '/AnalysisTools/Analysis'
            },
            {
              name: '相关性热图（组内）',
              path: '/AnalysisTools/Reporticawg'
            }
          ]
        }
      },
      {
        path: 'Normalization',
        name: 'Normalization',
        component: () => import('@/views/AnalysisTools/tools/normalization.vue'),
        meta: {
          title: '数据归一化/标准化处理',
          hidden: true,
          breadcrumb: [
            {
              name: '云工具',
              path: '/AnalysisTools/Analysis'
            },
            {
              name: '数据归一化/标准化处理',
              path: '/AnalysisTools/Normalization'
            }
          ]
        }
      },
      {
        path: 'Combinemore',
        name: 'Combinemore',
        component: () => import('@/views/AnalysisTools/tools/combinemore.vue'),
        meta: {
          title: '表格合并',
          hidden: true,
          breadcrumb: [
            {
              name: '云工具',
              path: '/AnalysisTools/Analysis'
            },
            {
              name: '表格合并',
              path: '/AnalysisTools/Combinemore'
            }
          ]
        }
      },
      {
        path: 'Transtable',
        name: 'Transtable',
        component: () => import('@/views/AnalysisTools/tools/transtable.vue'),
        meta: {
          title: '表格格式转换',
          hidden: true,
          breadcrumb: [
            {
              name: '云工具',
              path: '/AnalysisTools/Analysis'
            },
            {
              name: '表格格式转换',
              path: '/AnalysisTools/Transtable'
            }
          ]
        }
      },
      {
        path: 'Seniorvenn',
        name: 'Seniorvenn',
        component: () => import('@/views/AnalysisTools/tools/seniorvenn.vue'),
        meta: {
          title: 'UpSet韦恩图',
          hidden: true,
          breadcrumb: [
            {
              name: '云工具',
              path: '/AnalysisTools/Analysis'
            },
            {
              name: 'UpSet韦恩图',
              path: '/AnalysisTools/Seniorvenn'
            }
          ]
        }
      },
      {
        path: 'Reportvenn',
        name: 'Reportvenn',
        component: () => import('@/views/AnalysisTools/tools/reportvenn.vue'),
        meta: {
          title: '韦恩图',
          hidden: true,
          breadcrumb: [
            {
              name: '云工具',
              path: '/AnalysisTools/Analysis'
            },
            {
              name: '韦恩图',
              path: '/AnalysisTools/Reportvenn'
            }
          ]
        }
      },
      //工具11
      {
        path: 'Microbial',
        name: 'Microbial',
        component: () => import('@/views/AnalysisTools/process/microbial.vue'),
        meta: {
          title: '微生物多样性分析流程',
          hidden: true,
          breadcrumb: [
            {
              name: '云流程',
              path: '/AnalysisTools/Process'
            },
            {
              name: '微生物多样性分析流程',
              path: '/AnalysisTools/Microbial'
            }
          ]
        }
      },
      //工具12
      {
        path: 'Transcription',
        name: 'Transcription',
        component: () => import('@/views/AnalysisTools/visualization/transcription.vue'),
        meta: {
          title: '转录组数据可视化',
          hidden: true,
          breadcrumb: [
            {
              name: '云可视化',
              path: '/AnalysisTools/CloudVisualization'
            },
            {
              name: '转录组数据可视化',
              path: '/AnalysisTools/Transcription'
            }
          ]
        }
      },
       //工具13
      {
        path: 'DiffExpr',
        name: 'DiffExpr',
        component: () => import('@/views/AnalysisTools/process/diffExpr.vue'),
        meta: {
          title: '转录组分析',
          hidden: true,
          breadcrumb: [
            {
              name: '云流程',
              path: '/AnalysisTools/Process'
            },
            {
              name: '转录组分析',
              path: '/AnalysisTools/DiffExpr'
            }
          ]
        }
      },
      {
        path: 'Metagenomic',
        name: 'Metagenomic',
        component: () => import('@/views/AnalysisTools/process/metagenomic.vue'),
        meta: {
          title: '宏基因组分析',
          hidden: true,
          breadcrumb: [
            {
              name: '云流程',
              path: '/AnalysisTools/Process'
            },
            {
              name: '宏基因组分析',
              path: '/AnalysisTools/Metagenomic'
            }
          ]
        }
      },
      {
        path: 'Combined',
        name: 'Combined',
        component: () => import('@/views/AnalysisTools/process/combined.vue'),
        meta: {
          title: '转录代谢联合分析',
          hidden: true,
          breadcrumb: [
            {
              name: '云流程',
              path: '/AnalysisTools/Process'
            },
            {
              name: '转录代谢联合分析',
              path: '/AnalysisTools/Combined'
            }
          ]
        }
      },
      //任务详情
      {
        path: 'Detail/:id',
        name: 'Detail',
        component: () => import('@/views/AnalysisTools/detail.vue'),
        meta: {
          title: '任务列表',
          hidden: true,
          breadcrumb: [
            {
              name: '任务列表',
              path: '/AnalysisTools/Operation'
            }
          ]
        }
      }
    ]
  },

  {
    path: '/address',
    component: AppLayout,
    redirect: '/address/List',
    meta: {
      displayRoute: true,
    },
    children: [
      {
        path: 'List',
        name: 'address',
        component: () => import('@/views/Address/List.vue'),
        meta: {
          title: '我的地址',
          icon: require('@/assets/images/address.png'),
          hidden: true,
          alwaysShow:false,
          breadcrumb: [
            {
              name: '我的地址',
            }
          ]
        }
      },
      {
        path: 'ShippingAddress',
        name: 'ShippingAddress',
        component: () => import('@/views/Address/List.vue'),
        meta: {
          title: '下单地址',
          hidden: true,
          breadcrumb: [
            {
              name: '下单地址',
              path: '/address/ShippingAddress'
            }
          ]
        }
      },
    ]
  },
  {
    path: '/OrderOnline',
    component: AppLayout,
    redirect: '/OrderOnline/genePlaceOrder',
    meta: {
      title: '在线下单',
      icon: require('@/assets/images/orderOnline.png'),
      alwaysShow: true,
    },
    children: [
      {
        path: 'genePlaceOrder',
        name: 'genePlaceOrder',
        component: () => import('@/views/OrderOnline/gene/placeOrder.vue'),
        meta: {
          title: '基因下单',
          breadcrumb: [
            {
              name: '基因下单',
            }
          ]
        }
      },
      {
        path: 'commonPrimaryPlaceOrder',
        name: 'commonPrimaryPlaceOrder',
        component: () => import('@/views/OrderOnline/commonPrimary/placeOrder.vue'),
        meta: {
          title: '普通引物下单',
          breadcrumb: [
            {
              name: '普通引物下单',
            }
          ]
        }
      },
      {
        path: 'primaryPlaceOrder',
        name: 'primaryPlaceOrder',
        component: () => import('@/views/OrderOnline/primary/placeOrder.vue'),
        meta: {
          title: '修饰引物下单',
          breadcrumb: [
            {
              name: '修饰引物下单',
            }
          ]
        }
      },
      {
        path: 'RNAPlaceOrder',
        name: 'RNAPlaceOrder',
        component: () => import('@/views/OrderOnline/primary/RNAPlaceOrder.vue'),
        meta: {
          title: 'sgRNA引物下单',
          breadcrumb: [
            {
              name: 'sgRNA引物下单',
            }
          ]
        }
      },
      {
        path: 'QuoteDetail',
        name: 'QuoteDetail',
        component: () => import('@/views/quoteDetail/List.vue'),
        meta: {
          title: '基因下单详情',
          hidden: true,
          breadcrumb: [
            {
              name: '基因下单',
            },
            {
              name: '基因下单详情',
            }
          ]
        }
      },
      {
        path: 'DecorationDescription',
        name: 'DecorationDescription',
        component: () => import('@/views/OrderOnline/DecorationDescription.vue'),
        meta: {
          title: '中间修饰说明',
          hidden: true,
        }
      },
    ]
  },
  //购物车
  {
    path: '/ShoppingCart',
    component: AppLayout,
    redirect: '/MyCart/List',
    meta: {
      displayRoute: true,
    },
    children: [
      {
        path: 'List',
        name: 'ShoppingCart',
        component: () => import('@/views/ShoppingCart/List.vue'),
        meta: {
          title: '我的购物车',
          icon: require('@/assets/images/cart.png'),
          hidden: true,
          alwaysShow:false,
          breadcrumb: [
            {
              name: '我的购物车',
            }
          ]
        }
      },
      {
        path: 'GeneDetail',
        name: 'GeneDetail',
        component: () => import('@/views/quoteDetail/List.vue'),
        meta: {
          title: '基因订单详情',
          hidden: true,
          breadcrumb: [
            {
              name: '购物车列表',
              path: '/MyQuote/List'
            },
            {
              name: '基因订单详情',
            }
          ]
        }
      },
    ]
  },
  {
    path: '/MyQuote',
    component: AppLayout,
    redirect: '/MyQuote/List',
    children: [
      {
        path: 'List',
        name: 'MyQuote',
        component: () => import('@/views/MyQuote/List.vue'),
        meta: {
          title: '询价列表',
          icon: require('@/assets/images/inquiry.png'),
          breadcrumb: [
            {
              name: '询价列表',
            }
          ]
        }
      },
      {
        path: 'GeneDetail',
        name: 'GeneDetail',
        component: () => import('@/views/quoteDetail/List.vue'),
        meta: {
          title: '基因订单详情',
          hidden: true,
          breadcrumb: [
            {
              name: '询价列表',
              path: '/MyQuote/List'
            },
            {
              name: '基因订单详情',
            }
          ]
        }
      },
      {
        path: 'ModifiedPrimersDetail',
        name: 'ModifiedPrimersDetail',
        component: () => import('@/views/Primers/ModifiedPrimersDetail.vue'),
        meta: {
          title: '修饰引物订单详情',
          hidden: true,
          breadcrumb: [
            {
              name: '询价列表',
              path: '/MyQuote/List'
            },
            {
              name: '修饰引物订单详情',
            }
          ]
        }
      },
      {
        path: 'ComPrimersDetail',
        name: 'ComPrimersDetail',
        component: () => import('@/views/Primers/ComPrimersDetail.vue'),
        meta: {
          title: '普通引物订单详情',
          hidden: true,
          breadcrumb: [
            {
              name: '询价列表',
              path: '/MyQuote/List'
            },
            {
              name: '普通引物订单详情',
            }
          ]
        }
      },
      {
        path: 'SgRNAPrimersDetail',
        name: 'SgRNAPrimersDetail',
        component: () => import('@/views/Primers/SgRNAPrimersDetail.vue'),
        meta: {
          title: 'sgRNA引物订单详情',
          hidden: true,
          breadcrumb: [
            {
              name: '询价列表',
              path: '/MyQuote/List'
            },
            {
              name: 'sgRNA引物订单详情',
            }
          ]
        }
      },
      {
        path: 'ProductDetail',
        name: 'ProductDetail',
        component: () => import('@/views/Product/ProductDetail.vue'),
        meta: {
          title: '产品订单详情',
          hidden: true,
          breadcrumb: [
            {
              name: '询价列表',
              path: '/MyQuote/List'
            },
            {
              name: '产品订单详情',
            }
          ]
        }
      },
    ]
  },
  {
    path: '/OrderManage',
    component: AppLayout,
    redirect: '/OrderManage/genePlaceOrder',
    meta: {
      title: '订单管理',
      icon: require('@/assets/images/manage.png'),
      alwaysShow: true,
    },
    children: [
      {
        path: 'OrderInProgress',
        name: 'OrderInProgress',
        component: () => import('@/views/OrderManage/OrderInProgress.vue'),
        meta: {
          title: '进行中订单',
          displayRoute:true,
          breadcrumb: [
            {
              name: '进行中订单',
            }
          ]
        }
      },
      {
        path: 'GeneOrderList',
        name: 'GeneOrderList',
        component: () => import('@/views/GeneOrder/List.vue'),
        meta: {
          title: '基因订单',
          // icon: 'jiyin',
          breadcrumb: [
            {
              name: '基因订单',
            }
          ]
        },
      },
      {
        path: 'OrderDetail',
        component: () => import('@/views/OrderDetail/detail.vue'),
        meta: {
          title: '订单详情',
          hidden: true,
          breadcrumb: [
            {
              name: '基因订单',
              path: '/OrderManage/GeneOrderList'
            },
            {
              name: '订单详情',
            }
          ]
        }
      },
      {
        path: 'PrimerOrderList',
        name: 'PrimerOrderList',
        component: () => import('@/views/PrimerOrder/List.vue'),
        meta: {
          title: '引物订单',
          // icon: 'yinwu',
          breadcrumb: [
            {
              name: '引物订单',
            }
          ]
        },
      },{
        path: 'K3PrimersDetail',
        component: () => import('@/views/Primers/K3PrimersDetail.vue'),
        meta: {
          title: '订单详情',
          hidden: true,
          breadcrumb: [
            {
              name: '引物订单',
              path: '/OrderManage/PrimerOrderList'
            },
            {
              name: '订单详情',
            }
          ]
        }
      },
      {
        path: 'ProductOrderList',
        name: 'ProductOrderList',
        component: () => import('@/views/ProductOrder/List.vue'),
        meta: {
          title: '产品订单',
          breadcrumb: [
            {
              name: '产品订单',
            }
          ]
        }
      },
      {
        path: 'SequencingOrderList',
        name: 'SequencingOrderList',
        component: () => import('@/views/SequencingOrder/List.vue'),
        meta: {
          title: '测序订单',
          // icon: 'cexu',
          breadcrumb: [
            {
              name: '测序订单',
            }
          ]
        }
      },
      {
        path: 'SequencingOrderDetail',
        component: () => import('@/views/SequencingOrder/detail.vue'),
        meta: {
          title: '订单详情',
          hidden: true,
          breadcrumb: [
            {
              name: '测序订单',
              path: '/OrderManage/SequencingOrderList'
            },
            {
              name: '订单详情',
            }
          ]
        }
      },
      {
        path: 'SequencingOrderDetail',
        name: 'SequencingOrderDetail',
        component: () => import('@/views/SequencingOrder/detail.vue'),
        meta: {
          title: '订单详情',
          hidden: true,
          breadcrumb: [
            {
              name: '测序订单',
              path: '/OrderManage/SequencingOrderList'
            },
            {
              name: '订单详情',
            }
          ]
        }
      },
      {
        path: 'ProteinsAntibodiesList',
        name: 'ProteinsAntibodiesList',
        component: () => import('@/views/ProteinsAntibodies/List.vue'),
        meta: {
          title: '蛋白和抗体',
          displayRoute:true,
          breadcrumb: [
            {
              name: '蛋白和抗体',
            }
          ]
        }
      },
      {
        path: 'ReagentProductsList',
        name: 'ReagentProductsList',
        component: () => import('@/views/ReagentProducts/List.vue'),
        meta: {
          title: '试剂产品',
          displayRoute:true,
          breadcrumb: [
            {
              name: '试剂产品',
            }
          ]
        }
      },
      {
        path: 'SequencingResult',
        name: 'SequencingResult',
        component: () => import('@/views/OrderManage/SequencingResult.vue'),
        meta: {
          title: '测序结果下载',
          breadcrumb: [
            {
              name: '测序结果下载',
            }
          ]
        }
      },
      {
        path: 'MicrobialMap',
        name: 'MicrobialMap',
        component: () => import('@/views/MicrobialMap/index.vue'),
        meta: {
          title: '微生物地图',
          breadcrumb: [
            {
              name: '微生物地图',
            }
          ]
        }
      },
    ]
  },
]

export default routers
